import React from "react";
import logo from "./logo192.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="ds-footer mt-5">
      <div className="container">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 py-3">

          {/* Left: Logo */}
          <Link to="/" className="d-flex align-items-center gap-2 text-decoration-none">
            <img src={logo} alt="Logo" height="28" />
            <span className="fw-semibold text-dark" style={{ fontSize: 14 }}>
              RTM Program
            </span>
          </Link>

          {/* Middle: Copyright */}
          <div className="text-muted text-center" style={{ fontSize: 13 }}>
            © {new Date().getFullYear()} RTM Program. All rights reserved.
          </div>

          {/* Right: Links */}
          <div className="d-flex gap-3" style={{ fontSize: 13 }}>
            <Link to="/msmart" className="ds-footer-link">
              M-Smart
            </Link>
            <Link to="/courses" className="ds-footer-link">
              Training
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
